export const environment = {
  production: false,
  baseUrl: 'https://localhost:9002/',
  googleAnalyticsId: '',
  googleMapsAPIKey: 'AIzaSyA8KJ2hCvW_FAru_QS0mqcY_wFZVFpDfZs',
  recaptchaKey: '6LcYet0qAAAAAGG7mjvviK7ZjFaIi33E39Zys7IT',
};
